// src/pages/StorePage.js
import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import ProductDetailModal from '../components/ProductDetailModal';

function StorePage() {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await fetch('https://kifli-api.onrender.com/api/products');
                const data = await res.json();
                setProducts(data);
            } catch (error) {
                console.error("Error al cargar productos:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchProducts();
    }, []);

    if (isLoading) {
        return <div className="text-center text-xl">Cargando artículos...</div>;
    }

    return (
        <div className="max-w-7xl mx-auto px-8 py-10">
            <h1 className="text-4xl font-bold mb-8">Tienda</h1>
            
            {/* Cuadrícula de productos: 4 columnas en grande, 2 en tablet, 1 en móvil */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {products.map(product => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>

            <ProductDetailModal/>
        </div>
    );
}

export default StorePage;